import React from "react";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Row,
  Col,
  Select,
  Checkbox,
} from "antd";

import get from "lodash/get";
import { connect } from "react-redux";

import {
  updateFinanceCustomerRequest,
  createFinanceCustomerRequest,
} from "../../api/requests";

import {
  getFinanceCreatePermission,
  getFinanceUpdatePermission,
} from "../../reducers/user/selectors";

import classes from "./FinanceCustomerForm.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class FinanceCustomerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      showID: false,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const item = { ...values };

          if (this.props.id) {
            await updateFinanceCustomerRequest(this.props.id, item);
          } else {
            await createFinanceCustomerRequest(item);
          }

          this.setState({
            isLoading: false,
            requestResult: { type: "success", message: this.props.i18n.t("Success") },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const {
      financeUpdatePermission,
      financeCreatePermission,
      id,
      isNew,
      sites,
    } = this.props;

    const isEditable = id ? financeUpdatePermission : financeCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.id ? (
              <span>
                {this.props.name}{" "}
                <Badge count="Edit" style={{ backgroundColor: "#2968AE" }} />
              </span>
            ) : isNew ? (
              "Add customer"
            ) : (
              ""
            )}
          </h4>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Name")}:</b>
                <Form.Item>
                  {getFieldDecorator("name", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "name", ""),
                  })(<Input disabled={!isEditable} placeholder={this.props.i18n.t("Name")} />)}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Email")}</b>
                <Form.Item>
                  {getFieldDecorator("email", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "email"),
                  })(<Input type="email" />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Site ID")}</b>
                <Form.Item>
                  {getFieldDecorator("site_id", {
                    initialValue: get(this.props, "site_id"),
                  })(
                    <Select
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("Select Site ID")}
                      style={{ width: "100%" }}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      filterOption
                    >
                      {sites
                        .filter((site) => site.site_type === "randomization")
                        .map((site) => (
                          <Option key={site.id} value={site.id}>
                            {site.code} - {site.name}
                          </Option>
                        ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Supplier ID")}</b>
                <Form.Item>
                  {getFieldDecorator("supplier_number", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "supplier_number"),
                  })(<Input />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Phone")}:</b>
                <Form.Item>
                  {getFieldDecorator("phone", {
                    initialValue: get(this.props, "phone", ""),
                  })(<Input disabled={!isEditable} placeholder={this.props.i18n.t("Phone")} />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Contact")}{" "}1:</b>
                <Form.Item>
                  {getFieldDecorator("contact_1", {
                    initialValue: get(this.props, "contact_1", ""),
                  })(
                    <Input.TextArea
                      disabled={!isEditable}
                      placeholder="Contact 1"
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Contact")}{" "}2:</b>
                <Form.Item>
                  {getFieldDecorator("contact_2", {
                    initialValue: get(this.props, "contact_2", ""),
                  })(
                    <Input.TextArea
                      disabled={!isEditable}
                      placeholder="Contact 2"
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Currency")}:</b>
                <Form.Item>
                  {getFieldDecorator("currency", {
                    initialValue: get(this.props, "currency", ""),
                  })(
                    <Select disabled={!isEditable}>
                      <Option value="CAD">CAD</Option>
                      <Option value="USD">USD</Option>
                      <Option value="EUR">EUR</Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <h5>{this.props.i18n.t("NamespaceFinanceCustomerForm:Billing")}</h5>

          <Row gutter={12}>
            <Col>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Billing address")}1:</b>
                <Form.Item>
                  {getFieldDecorator("billing_address_1", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "billing_address_1", ""),
                  })(
                    <Input.TextArea
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Billing address 1")}
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Billing address")}{" "}2:</b>
                <Form.Item>
                  {getFieldDecorator("billing_address_2", {
                    initialValue: get(this.props, "billing_address_2", ""),
                  })(
                    <Input.TextArea
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Billing address 2")}
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Billing city")}:</b>
                <Form.Item>
                  {getFieldDecorator("billing_city", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "billing_city", ""),
                  })(
                    <Input disabled={!isEditable} placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Billing city")} />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Billing postal zip code")}:</b>
                <Form.Item>
                  {getFieldDecorator("billing_postal_zip_code", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(
                      this.props,
                      "billing_postal_zip_code",
                      ""
                    ),
                  })(
                    <Input
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Billing postal zip code")}
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Billing country")}:</b>
                <Form.Item>
                  {getFieldDecorator("billing_country", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "billing_country", ""),
                  })(
                    <Select
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Select Billing country")}
                      style={{ width: "100%" }}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      filterOption
                    >
                      <Option value='canada'>{this.props.i18n.t("Canada")}</Option>
                      <Option value='united_states'>{this.props.i18n.t("USA")}</Option>
                      <Option value='australia'>{this.props.i18n.t("Australia")}</Option>
                      <Option value='europe'>{this.props.i18n.t("Europe")}</Option>
                      <Option value='asia'>{this.props.i18n.t("Asia")}</Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Billing province state")}:</b>
                <Form.Item>
                  {getFieldDecorator("billing_province_state", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "billing_province_state", ""),
                  })(
                    <Input
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Billing province state")}
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <h5>{this.props.i18n.t("NamespaceFinanceCustomerForm:Banking info")}</h5>

          <Row gutter={12}>
            <Col span={24}>
              <label>
                {getFieldDecorator("banking_enabled", {
                  initialValue: get(this.props, "banking_enabled", false),
                  valuePropName: "checked",
                })(<Checkbox disabled={!isEditable}>{this.props.i18n.t("NamespaceFinanceCustomerForm:Banking enabled")}</Checkbox>)}
              </label>
            </Col>
          </Row>
          <br />

          {getFieldValue("banking_enabled") && (
            <Row gutter={12}>
              <Col>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Banking name")}:</b>
                  <Form.Item>
                    {getFieldDecorator("banking_name", {
                      initialValue: get(this.props, "banking_name", ""),
                    })(
                      <Input
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Banking name")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
              <Col>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Banking address 1")}:</b>
                  <Form.Item>
                    {getFieldDecorator("banking_address_1", {
                      initialValue: get(this.props, "banking_address_1", ""),
                    })(
                      <Input
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Banking address 1")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
              <Col>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Banking address 2")}:</b>
                  <Form.Item>
                    {getFieldDecorator("banking_address_2", {
                      initialValue: get(this.props, "banking_address_2", ""),
                    })(
                      <Input
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Banking address 2")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Banking account number")}:</b>
                  <Form.Item>
                    {getFieldDecorator("banking_account_number", {
                      initialValue: get(
                        this.props,
                        "banking_account_number",
                        ""
                      ),
                    })(
                      <Input
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Banking account number")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Banking IBAN code")}:</b>
                  <Form.Item>
                    {getFieldDecorator("banking_iban_code", {
                      initialValue: get(this.props, "banking_iban_code", ""),
                    })(
                      <Input
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Banking IBAN code")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Banking swift code")}:</b>
                  <Form.Item>
                    {getFieldDecorator("banking_swift_code", {
                      initialValue: get(this.props, "banking_swift_code", ""),
                    })(
                      <Input
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Banking swift code")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Banking account name")}:</b>
                  <Form.Item>
                    {getFieldDecorator("banking_account_name", {
                      initialValue: get(this.props, "banking_account_name", ""),
                    })(
                      <Input
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Banking account name")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Banking account holder address")}:</b>
                  <Form.Item>
                    {getFieldDecorator("banking_account_holder_address", {
                      initialValue: get(
                        this.props,
                        "banking_account_holder_address",
                        ""
                      ),
                    })(
                      <Input
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Banking account holder address")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
            </Row>
          )}

          <h5>{this.props.i18n.t("NamespaceFinanceCustomerForm:Shipping")}</h5>

          <Row gutter={12}>
            <Col span={24}>
              <label>
                {getFieldDecorator("shipping_enabled", {
                  initialValue: get(this.props, "shipping_enabled", false),
                  valuePropName: "checked",
                })(
                  <Checkbox disabled={!isEditable}>{this.props.i18n.t("NamespaceFinanceCustomerForm:Shipping enabled")}</Checkbox>
                )}
              </label>
            </Col>
          </Row>
          <br />

          {getFieldValue("shipping_enabled") && (
            <Row gutter={12}>
              <Col>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Shipping address 1")}:</b>
                  <Form.Item>
                    {getFieldDecorator("shipping_address_1", {
                      initialValue: get(this.props, "shipping_address_1", ""),
                    })(
                      <Input.TextArea
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Shipping address 1")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
              <Col>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Shipping address 2")}:</b>
                  <Form.Item>
                    {getFieldDecorator("shipping_address_2", {
                      initialValue: get(this.props, "shipping_address_2", ""),
                    })(
                      <Input.TextArea
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Shipping address 2")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Shipping city")}:</b>
                  <Form.Item>
                    {getFieldDecorator("shipping_city", {
                      initialValue: get(this.props, "shipping_city", ""),
                    })(
                      <Input
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Shipping city")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Shipping postal zip code")}:</b>
                  <Form.Item>
                    {getFieldDecorator("shipping_postal_zip_code", {
                      initialValue: get(
                        this.props,
                        "shipping_postal_zip_code",
                        ""
                      ),
                    })(
                      <Input
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Shipping postal zip code")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Shipping country")}:</b>
                  <Form.Item>
                    {getFieldDecorator("shipping_country", {
                      initialValue: get(this.props, "shipping_country", ""),
                    })(
                      <Input
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Shipping country")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Shipping province state")}:</b>
                  <Form.Item>
                    {getFieldDecorator("shipping_province_state", {
                      initialValue: get(
                        this.props,
                        "shipping_province_state",
                        ""
                      ),
                    })(
                      <Input
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Shipping province state")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
            </Row>
          )}

          <h5>{this.props.i18n.t("More")}</h5>
          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Account number")}:</b>
                <Form.Item>
                  {getFieldDecorator("account_number", {
                    initialValue: get(this.props, "account_number", ""),
                  })(
                    <Input
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Account number")}
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Fax")}:</b>
                <Form.Item>
                  {getFieldDecorator("fax", {
                    initialValue: get(this.props, "fax", ""),
                  })(<Input disabled={!isEditable} placeholder={this.props.i18n.t("Fax")} />)}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Mobile")}:</b>
                <Form.Item>
                  {getFieldDecorator("mobile", {
                    initialValue: get(this.props, "mobile", ""),
                  })(<Input disabled={!isEditable} placeholder={this.props.i18n.t("Mobile")} />)}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Toll free")}:</b>
                <Form.Item>
                  {getFieldDecorator("toll_free", {
                    initialValue: get(this.props, "toll_free", ""),
                  })(<Input disabled={!isEditable} placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Toll free")} />)}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("Website")}:</b>
                <Form.Item>
                  {getFieldDecorator("website", {
                    initialValue: get(this.props, "website", ""),
                  })(<Input disabled={!isEditable} placeholder={this.props.i18n.t("website")} />)}
                </Form.Item>
              </label>
            </Col>
            <Col span={24}>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceCustomerForm:Internal notes")}:</b>
                <Form.Item>
                  {getFieldDecorator("internal_notes", {
                    initialValue: get(this.props, "internal_notes", ""),
                  })(
                    <Input.TextArea
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("NamespaceFinanceCustomerForm:Internal notes")}
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <br />

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                >
                  Save
                  {isLoading && <Icon type="loading" />}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  financeCreatePermission: getFinanceCreatePermission(state),
  financeUpdatePermission: getFinanceUpdatePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "customer" })(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(FinanceCustomerForm))
);



// WEBPACK FOOTER //
// ./src/components/FinanceCustomerForm/FinanceCustomerForm.js